import React from "react";
import "./HowItWorks.css";

export default function HowItWorks() {
  return (
    <section className="how-it-works-section" id="overview-section">
      <div className="how-it-works-container">
        <h2>How It Works</h2>
        <p>
          Our innovative technology allows healthcare professionals to connect
          with clients anywhere in the world, gather precise measurements, and
          apply the data to create customized prosthetics and other medical
          solutions.  
          <br /><br />
          Step 1: The client takes a photo of the required body part using their device. A reference page (with measurement markers or scaling guides) is included in the photo to ensure accuracy.
<br></br>
<br></br>
Step 2: MediMetrics scans and analyzes the photo, extracting precise measurements using advanced imaging and scaling technology.
<br></br>
<br></br>
Step 3: The data is securely stored on the platform, ensuring privacy and compliance with healthcare standards.
<br></br>
<br></br>
Step 4: The healthcare provider receives the processed measurements and client data directly through MediMetrics.
        </p>
      </div>
    </section>
  );
}
